import React from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import Modal from "../../UI/Modal/Modal";
import Navigations from "../../Common/Navigations/Navigations";
import CVDownload from "../Navigation/CVDownload/CVDownload";
import ThemeToggle from "../../UI/ThemeToggle/ThemeToggle";
import SocialHandles from "../../Common/SocialHandles/SocialHandle";
import classes from "./SideDrawal.module.css";

const SideDrawal = (props) => {
  return createPortal(
    <>
      <AnimatePresence>
        {props.status && <Modal click={props.click} />}
      </AnimatePresence>
      <AnimatePresence>
        {props.status && (
          <motion.div
            className={classes.SideDrawal}
            initial={{ x: "100%" }}
            animate={{ x: "0%" }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
          >
            <div className={classes.CloseBar}>
              <button className={classes.CloseBtn} onClick={props.click} aria-label="Close menu">
                ✕
              </button>
            </div>
            <Navigations CSSstyle={classes.NavCSS} click={props.click} />
            <div className={classes.ContactButton}>
              <CVDownload click={props.click} />
              <div className={classes.ThemeToggleWrap}>
                <ThemeToggle />
              </div>
              <div className={classes.SideDrawalSocailHandles}>
                <SocialHandles />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>,
    document.body
  );
};

export default SideDrawal;
